import type { PlacementPosition, SizeMm, Surface, SurfacePoint } from '@repo/api-contracts';
import type { PhotoDimensions, PhotoRect } from '../types';
import { cylinderCenterScale, cylinderPhotoToMm } from './cylinder-mapping';
import { componentRectOnPhoto, flatScale, photoToSurfaceMm } from './flat-mapping';

/** 표면 타입으로 분기하는 mm↔사진 변환. mesh 는 런타임 엔진이 없어 null 이다(ADR-0007 D10). */
export const surfaceScale = (surface: Surface, photo: PhotoDimensions): SurfacePoint | null => {
  if (surface.type === 'flat') return flatScale(surface, photo);
  if (surface.type === 'cylinder') return cylinderCenterScale(surface, photo);
  return null;
};

export const surfaceRectOnPhoto = (
  surface: Surface,
  photo: PhotoDimensions,
  size: SizeMm,
  position: PlacementPosition,
): PhotoRect | null =>
  surface.type === 'flat' ? componentRectOnPhoto(surface, photo, size, position) : null;

export const surfacePhotoToMm = (
  surface: Surface,
  photo: PhotoDimensions,
  point: SurfacePoint,
): PlacementPosition | null => {
  if (surface.type === 'flat') return photoToSurfaceMm(surface, photo, point);
  if (surface.type === 'cylinder') return cylinderPhotoToMm(surface, photo, point);
  return null;
};
